import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next'

import * as constants from '../../utils'

import TextInput from './TextInput'
import { KeyInfo } from './types'

export type KeyFormProps = {
  keyInfo: KeyInfo
  onSave: () => void
  onChange: (event: any) => void
  onGoBack: () => void
}

const KeyForm = ({ keyInfo, onSave, onChange, onGoBack }: KeyFormProps) => {
  const { t } = useTranslation()
  const [errors, setErrors]: any = useState({})
  const [saving, setSaving] = useState(false)
  const [dataUnChanged, setDataUnChanged] = useState(true)
  const [showModal, setShowModal] = useState(true)
  const handleCloseModal = () => setShowModal(false)

  const handleChange = (event) => {
    setDataUnChanged(false)
    onChange(event)
  }

  const handleSave = (event) => {
    event.preventDefault()
    if (!formsIsValid()) return
    setSaving(true)
    onSave()
  }

  const handleEnterKeyPress = (event) => {
    event.key == 'Enter' && event.preventDefault()
  }

  const formsIsValid = () => {
    if (keyInfo && keyInfo.keyName) {
      keyInfo.keyName = keyInfo.keyName.trim()
    }

    const { keyId, keyName, aadRevocation } = keyInfo
    const errors: any = {}

    if (!keyId) errors.keyId = t('key_error.keyId')
    if (!keyName || keyName.trim() == '')
      errors.keyName = t('key_error.keyName')
    else if (keyName.length > constants.maxKeyNameLength)
      errors.keyName = t('key_error.key_name_length')
    if (!aadRevocation || aadRevocation.trim() == '')
      errors.aadRevocation = t('key_error.aad_revocation')

    setErrors(errors)
    return Object.keys(errors).length === 0
  }

  const KeyId = () => (
    <TextInput
      name="keyId"
      label={t('key.key_id')}
      value={keyInfo.keyId}
      onChange={handleChange}
      error={errors.keyId}
      disabled={true}
    />
  )

  const Buttons = () => (
    <>
      <button
        className="responsive-button btn btn-secondary mr-2"
        onClick={handleCloseModal}
      >
        {t('close')}
      </button>
      <button
        type="submit"
        disabled={saving || dataUnChanged}
        className="responsive-button btn btn-primary"
      >
        {saving ? t('saving') : t('save')}
      </button>
    </>
  )

  return (
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      onExited={onGoBack}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={handleSave} className="container">
        <Modal.Header className="responsive-button" closeButton>
          <Modal.Title>{t('key.edit')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errors.onSave && (
            <div className="alert alert-danger responsive-font" role="alert">
              {errors.onSave}
            </div>
          )}
          <KeyId />
          <hr />

          <Form.Group controlId="formFile" className="mb-3">
            <TextInput
              name="keyName"
              label={t('key.name')}
              value={keyInfo.keyName}
              onChange={handleChange}
              onKeyDown={handleEnterKeyPress}
              error={errors.keyName}
              disabled={false}
            />
          </Form.Group>

          <Form.Group controlId="formFile" className="mb-3">
            <TextInput
              name="aadRevocation"
              label={t('key.aad_revocation')}
              value={keyInfo.aadRevocation}
              onChange={handleChange}
              onKeyDown={handleEnterKeyPress}
              error={errors.aadRevocation}
              disabled={false}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Buttons />
        </Modal.Footer>
      </form>
    </Modal>
  )
}
export default KeyForm
